
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flows",
      function () {
        return require("private-next-pages/flows/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flows"])
      });
    }
  